import { render, staticRenderFns } from "./USDIRReport.vue?vue&type=template&id=9726c3e0&scoped=true&"
import script from "./USDIRReport.vue?vue&type=script&lang=ts&"
export * from "./USDIRReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9726c3e0",
  null
  
)

export default component.exports